import React,{useState,useEffect, useCallback} from "react";

///Styles
import moment from "moment";
import { toast } from "react-toastify";
import { ContainerLoading,Container,Content,Groups,TableProducts,Button } from "./styles";

///Components
import { SpaceLoader } from "../../../../loaders/spaceLoader";
import { formatMoney } from "../../../../../Utils/formatMoney";
import { ButtonExportExcel } from "../../buttonExportExcel";

///Services
import { useAdministrativeContext } from "../../../../../pages/administrativePanel/administrativePanelContext";
import { api } from "../../../../../services/api";
import { download_csv } from "../../centralizedModal/JsonToCsv";



export function CanceledSales(){
    const { 
        startDate, 
        endDate, 
        listBusinessToFilter,
        listSalesChannelsId 
    } = useAdministrativeContext();

    const [sales,setSales] = useState([]);
    const [page,setPage] = useState(1)
    const [loading,setLoading] = useState(true);
    const [loadingButton, setLoadingButton] = useState(false);
    const [openButton,setOpenButton] = useState(false)

    const handleFetchNewDates = useCallback(async () => {
        setLoadingButton(true);
        const response = await api.post(`/getCanceledOrders?page=${page}`,
        {
            business: listBusinessToFilter,
            salesChannels: listSalesChannelsId,
            endDate: endDate,
            startDate: startDate
        },
        {
            headers: {
                'Content-Type': 'application/json',
                 token: localStorage.getItem('@Inoveclube:token')
            }
        });

        //console.log(response.data)
        const data = handleData(response.data.datas)
        setSales([...sales,...data]);
        setPage(response.data.next_page)
        setLoadingButton(false);
    },[endDate,listBusinessToFilter,listSalesChannelsId,page,sales,startDate]);

    useEffect(()=>{
        async function loadSalesCanceled(){
            setLoading(true)
            await api.post('/getCanceledOrders?page=1',
            {
                business:  listBusinessToFilter,
                salesChannels: listSalesChannelsId,
                endDate: endDate,
                startDate: startDate
            },
            {
                headers: {
                    'Content-Type': 'application/json',
                     token: localStorage.getItem('@Inoveclube:token')
                }
            })
            .then((response) => {
                const {datas,next_page} = response.data;
                //console.log(datas)
                setSales(handleData(datas));
                setPage(next_page);
                setLoading(false)
            })
            .catch((error) => {
                toast.error('Ops, algo deu errado')
                setLoading(false)
            })
        }
        loadSalesCanceled();
    },[endDate,listBusinessToFilter,listSalesChannelsId,startDate]);

    const handleData = (data) => {
        const result = Object.entries(data.reduce((acc, {RowNum, cancellationDate,dateOrder,idBusiness,idCustomized,nameBusiness,nameEmployee,namePerson,note,numberOrder,salesChannel,value}) => {
            acc[nameBusiness] = (acc[nameBusiness] || []);
            acc[nameBusiness].push({
                RowNum, 
                cancellationDate,
                dateOrder,
                idBusiness,
                idCustomized,
                nameEmployee,
                namePerson,
                note,
                numberOrder,
                salesChannel,
                value
            });
            return acc;
        },{}))
        .map(([key, value]) => ({name: key, children: value}));
        return result
    }

    async function handleDownloadCSV(){
        setLoading(true);
        await api.post('/getCanceledOrders?page=0',
        {
            business:  listBusinessToFilter,
            salesChannels: listSalesChannelsId,
            endDate: endDate,
            startDate: startDate
        },
        {
            headers: {
                'Content-Type': 'application/json',
                 token: localStorage.getItem('@Inoveclube:token')
            }
        })
        .then((response) => {
            const {datas} = response.data;
        
            const newArr = datas.map((item) => {
                return{
                    Codigo: item.idBusiness,
                    Id_Customizado: item.idCustomized,
                    CNPJ: item.cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5"),
                    Empresa: item.nameBusiness,
                    Cliente: item.namePerson,
                    Funcionário_Cancelamento: item.nameEmployee,
                    Canal_Venda: item.salesChannel,
                    Data_Cancelamento: moment(item.cancellationDate).format('DD/MM/YY HH:mm:ss'),
                    Valor: Number(item.value).toFixed(2).replace('.',','),
                    Motivo: item.note,
                }
            })
            download_csv(newArr, 'Vendas Canceladas')
            setLoading(false);
        })
        .catch((error) => {
            toast.error('Ops, algo deu errado');
        })
    }

    if(loading){
        return(
            <ContainerLoading>
                <SpaceLoader colorLoader="var(--colorFontsCardsDashboard)" />
            </ContainerLoading>
        )
    }

    return(
        <Container>
            <ButtonExportExcel
                open={openButton}
                setOpen={setOpenButton}
                handleDownloadCSV={handleDownloadCSV}
            />

            <Content>
            {
                sales.map((business,index) => {
                    return(
                        <Groups key={index}>
                            <h3>&#8226;{business.name}</h3>

                            <TableProducts>
                                <thead>
                                    <tr>
                                        <th>Cliente</th>
                                        <th>Pedido</th>
                                        <th>Funcionário Cancelamento</th>
                                        <th>Canal Venda</th>
                                        <th>Data Cancelamento</th>
                                        <th>Valor</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {
                                        business.children.map((item) => {
                                            return(
                                                <tr key={item.numberOrder}>
                                                    <td>
                                                        {item.namePerson}
                                                        {item.note.length !== 0 &&
                                                            <p>Motivo: {item.note}</p>
                                                        }
                                                    </td>
                                                    <td>{item.numberOrder}</td>
                                                    <td>{item.nameEmployee.split(' ').slice(0,1)}</td>
                                                    <td>{item.salesChannel}</td>
                                                    <td>{moment(item.cancellationDate).format('DD/MM/YYYY hh:mm')}</td>
                                                    <td>{formatMoney(item.value)}</td>
                                                </tr>
                                            )
                                        })
                                    }

                                    <tr>
                                            <td>Total:</td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td>
                                            {
                                                formatMoney(
                                                    business.children.map((item) => {
                                                        return item.value
                                                    })
                                                    .reduce((value,next) => {
                                                        return value + next
                                                    })
                                                )
                                            }
                                            </td>
                                    </tr>
                                </tbody>
                            </TableProducts>
                        </Groups>
                        
                    )
                })
            }
            </Content>

            {
                page !== null &&
                <Button onClick={handleFetchNewDates} loadingButton={loadingButton}>
                    {
                        loadingButton ? 
                        '...aguarde'
                        :
                        'Ver mais'
                    }
                </Button>
            }
        </Container>
    )
}